import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { MaterialModule } from './material/material.module';
import { AppRoutingModule } from './app-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule, HttpParams } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { MomentModule } from 'ngx-moment';
import { SharedModule } from '@shared/shared.module';
import { RequestInterceptor } from './core/interceptors/request.interceptor';
import { TextFieldModule } from '@angular/cdk/text-field';
import { NgDynamicBreadcrumbModule } from 'ng-dynamic-breadcrumb';
import { NgScrollbarModule } from 'ngx-scrollbar';

import { AppComponent } from './app.component';
import { AuthGuard } from './core/guards/auth.guard';
import { PageNotFoundComponent } from './core/errorpages/page-not-found/page-not-found.component';
import { UnauthorizedComponent } from './core/errorpages/unauthorized/unauthorized.component';
import { QuillModule } from 'ngx-quill';
import { LoggerModule, NgxLoggerLevel } from 'ngx-logger';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { NgxSpinnerModule } from 'ngx-spinner';
import { HomeModule } from '@modules/home/home.module';
import { environment } from '@environments/environment';
import { CustomLoader } from '@shared/utilities/custom-loader';
import { LinkExpireComponent } from './core/errorpages/link-expire/link-expire.component';
import { RecaptchaModule, RecaptchaFormsModule } from 'ng-recaptcha';   // GAHR-1468
import { OktaAuthModule } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';

//GAHR1553
const oktaAuth = new OktaAuth({
  issuer: environment.okta.issuer,
  clientId: environment.okta.clientId,
  redirectUri: environment.okta.redirectUri
});
@NgModule({
  declarations: [AppComponent, PageNotFoundComponent, UnauthorizedComponent, LinkExpireComponent],
  imports: [
    NgxSpinnerModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    NgDynamicBreadcrumbModule,
    NgScrollbarModule,
    NgxSpinnerModule,
    SharedModule,
    HomeModule,
    DragDropModule,
    QuillModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: CustomLoader,
        deps: [HttpClient],
      },
    }),
    NgIdleKeepaliveModule.forRoot(),
    MaterialModule,
    TextFieldModule,
    MomentModule.forRoot({
      relativeTimeThresholdOptions: {
        m: 59,
      },
    }),
    LoggerModule.forRoot({
      level: NgxLoggerLevel.DEBUG,
      enableSourceMaps: true,
      colorScheme: ['purple', 'teal', 'teal', 'lightblue', 'orange', 'red', 'red'],
    }),
    RecaptchaModule,
    RecaptchaFormsModule,
    OktaAuthModule.forRoot({ oktaAuth })//GAHR1553
  ],
  providers: [
    AuthGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RequestInterceptor,
      multi: true,
    },
    {
      provide: Window,
      useValue: window,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}